export const NON_APPLICABLE = 'N/A';
export const PLAN_TYPE_SOURCE = 'source';
export const PLAN_TYPE_DESTINATION = 'destination';
export const NEW_PLAN_ID = 'newPlan';
